<template>
  <fragment>
    <b-row class="location-filter-input">
      <b-col cols="12" class="mx-2 d-flex justify-content-start">
        <b-form-radio-group
          stacked
          class="v3_control_radio_group"
          :checked="locationPreferenceType"
          :options="locationPreferenceOptions"
          @change="onChangeHandler"
        />
      </b-col>
    </b-row>
    <region-form
      ref="preference_sub_form"
      v-if="locationPreferenceType === 'region'"
      :preference-data="locationData"
      @set-preference="onUpdatePreference"
    />
    <state-geography-form
      ref="preference_sub_form"
      v-else-if="locationPreferenceType === 'state'"
      :preference-data="locationData"
      @set-preference="onUpdatePreference"
    />
    <area-geography-form
      ref="preference_sub_form"
      v-else-if="locationPreferenceType === 'metropolitan'"
      :preference-data="locationData"
      @set-preference="onUpdatePreference"
    />
  </fragment>
</template>

<script>
import { validationMixin } from 'vuelidate';
import validateStateMixin from '@/mixins/validateStateMixin';
import RegionForm from '@/components/exchange/preference-charts-inputs/RegionForm';
import StateGeographyForm from '@/components/exchange/preference-charts-inputs/StateGeographyForm';
import AreaGeographyForm from '@/components/exchange/preference-charts-inputs/AreaGeographyForm';
import {
  GEOGRAPHIC_PREFERENCE,
  GEOGRAPHIC_PREFERENCE_OPTIONS_NAMES,
} from '@/helpers/jobQuestionsHelper';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'LocationSelectorForFilter',
  mixins: [validationMixin, validateStateMixin],
  components: {
    RegionForm,
    StateGeographyForm,
    AreaGeographyForm,
  },
  props: {
    locationData: Object,
  },
  validations: {
    locationPreferenceType: {
      required,
    },
  },
  computed: {
    locationPreferenceOptions: function () {
      return Object.keys(GEOGRAPHIC_PREFERENCE_OPTIONS_NAMES)
        .filter((key) => key !== GEOGRAPHIC_PREFERENCE.NO_PREFERENCE)
        .map((key) => ({
          value: key,
          text: GEOGRAPHIC_PREFERENCE_OPTIONS_NAMES[key],
        }));
    },
    locationPreferenceType: function () {
      return this.locationData ? this.locationData.type : null;
    },
    locationPreferenceValue: function () {
      return this.locationData ? this.locationData.value : null;
    },
  },
  methods: {
    onChangeHandler: function (checkedValue) {
      this.$emit('set-location-data', {
        type: checkedValue,
        value: null,
      });
      this.$v.locationPreferenceType.$touch();
    },
    onUpdatePreference: function (data) {
      this.$emit('set-location-data', data);
    },
    isDirty: function () {
      return (
        this.$v.type.$dirty ||
        (this.$refs.preference_sub_form &&
          this.$refs.preference_sub_form.isDirty())
      );
    },
    resetValidation: function () {
      this.$v.locationPreferenceType.$reset();
      if (this.$refs.preference_sub_form) {
        this.$refs.preference_sub_form.resetValidation();
      }
    },
    validate: function () {
      this.$v.$touch();
      if (this.$refs.preference_sub_form) {
        this.$refs.preference_sub_form.validate();
      }
    },
    isInValid: function () {
      return (
        this.$v.$anyError ||
        (this.$refs.preference_sub_form &&
          this.$refs.preference_sub_form.hasErrors())
      );
    },
  },
};
</script>

<style lang="scss">
@import '../../../../../sass/variables_mixins';
.location-filter-input {
  .custom-control {
    margin: 0.5rem 0;
    .custom-control-label {
      padding-left: 0.5rem;
    }
  }
}
</style>
